import urls from '../api_urls/activityLog'
import { _post } from '@/axios/request'
// 获取列表
export function getTableData (params) {
  return _post(urls.GET_LIST, params)
}
// 是否可以下载或预览
export function getCanDownload (params) {
  return _post(urls.CAN_DOWNLOAD, params)
}
// 详情页的文件是否可以下载或预览
export function getCanDownloadDetail (params) {
  return _post(urls.CAN_DOWNLOAD_DETAIL, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/activityLog.js